import { useEffect, useState } from "react";

/**
 * Returns false for the first `delayMs` after mount, then true.
 * Used to suppress loading UI on fast loads: nothing renders during the
 * gate window, so a page that resolves quickly never flashes a loader.
 * StrictMode-safe (timer created and cleared inside one effect).
 */
export function useDelayGate(delayMs: number): boolean {
  const [open, setOpen] = useState(delayMs <= 0);

  useEffect(() => {
    if (delayMs <= 0) return;
    const id = window.setTimeout(() => setOpen(true), delayMs);
    return () => window.clearTimeout(id);
  }, [delayMs]);

  return open;
}
